import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, PRIMARY_OUTLET, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import * as signalR from '@microsoft/signalr';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { FeatureCode, ModuleNames, SignalRHubEventType } from 'projects/Autofacets-Core/src/app/utils/enums';
import * as p from 'public-ip';
import { Subscription, timer } from 'rxjs';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { CallDialRequestModel, CallHistoryRequestModel } from '../../business-entities/call-request-model';
import { NotificationRequestViewModel } from '../../business-entities/notification-details-result-view-model';
import { Features } from '../../business-entities/user-role-view-model';
import { CallerService } from '../../business-services/caller.service';
import { DashboardService } from '../../business-services/dashboard.service';
import { EditAppointmentService } from '../../business-services/edit-appointment.service';
import { SettingService } from '../../business-services/setting.service';
import { CultureLocaleService } from '../../services/culture-locale.service';
import { LanguageService } from './../../business-services/language.service';
import { CallerInfoComponent } from './caller-info/caller-info.component';
import { AppointmentService } from '../../business-services/appointment.service';
import { WhatsAppLogService } from '../../business-services/whatsapp-log.service';
import { WhatsAppUnrepliedModel } from '../../business-entities/whatsapp-unreplied-model';
import { environment } from 'projects/Administration/src/environments/environment';
import { map, share } from 'rxjs/operators';
import * as moment from 'moment';

interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
}
@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.css'],

})

export class HeaderComponent implements OnInit {
  public breadcrumbs: IBreadcrumb[];
  currentDateTime: Promise<Date>;
  currentSignedInUser: string;
  currentUserRole: string;
  languages: any[];
  currentLang: string;
  popupCloseResult = false;
  selectedLanguageFlag: string;
  selectedLanguageText: string;
  selectedLangExpireDate = new Date();
  isLanguageDropDown: boolean = false;
  appointmentSub: Subscription;
  languageSub: Subscription;
  notificationCount: number = 0;
  notificationPopupOpen: boolean = false;
  notificationList: any = [];
  logoUrlLink: string;
  WidgetLogoUrlLink: string;
  isShowNotification: boolean;
  userRoleMenuDetails: any;
  dialNumber: string;
  isCdssUser: boolean = false;
  isWidgetAvailable: boolean = true;
  isProd: boolean = false;
  notifictionRequestModel: NotificationRequestViewModel =
    {
      userId: null,
      isRead: null,
      searchTerm: "",
      startRecordNo: 0,
      numberOfRecord: 25
    };
  isPbxEnabled: boolean = false;
  lstFeatures: Features[] = [];
  callFromNumber: string;
  callPopupList: any[] = [];

  unrepliedWhatsAppMessages: WhatsAppUnrepliedModel[];
  whatsAppNotificationCount = 0;
  whatsAppNotificationPopupOpen: boolean = false;
  isShowWhatsAppNotification: boolean = false;
  whatsAppNotificationInterval: any;
  whatsAppNotificationRefreshInterval: number = +EnvSetting.WhatsAppNotificationRefreshInterval;
  isWhatsappFeatureActive: boolean = false;
  isUserStampInOutActive: boolean =false;
  stampInTime = '';
  stampTimeSubscription: Subscription;

  constructor(
    private languageService: LanguageService,
    private cookieservice: CookieService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private currentLanguageService: CurrentLanguage,
    private userService: UserDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private msalService: MsalService,
    private titleService: Title,
    private globalSetting: GlobalSetting,
    private secureStorage: SecureStorage,
    private dashboardService: DashboardService,
    private callerService: CallerService,
    private _eref: ElementRef,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private settingService: SettingService,
    public editAppointmentService: EditAppointmentService,
    public cultureLocaleService: CultureLocaleService,
    public appointmentService: AppointmentService,
    private whatsAppLogService: WhatsAppLogService
  ) {
    this.breadcrumbs = [];
    this.listenRouting();
  }
  ngOnInit(): void {
    this.isProd = environment.production;
    this.isWidgetAvailable = localStorage.getItem('Theme') !== 'mg';
    this.GetFeature();
    this.appointmentSub = this.currentLanguageService.breadcrumbs.subscribe(x => {
      this.breadcrumbs = x;
    });
    this.cultureLocaleService.globalSettingValues.subscribe(res => {
      if (res?.length > 0) {
        let logo = res.find(x => x.property === 'LogoUrlLink');
        let widgetLogoUrlLink = res.find(x => x.property === 'WidgetLogoUrlLink');

        this.logoUrlLink = logo?.value;
        this.WidgetLogoUrlLink = widgetLogoUrlLink?.value;
      
        this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
        this.selectedLanguageText = EnvSetting.LANGUAGE_CONFIG.defaultLanguageText;
        this.selectedLanguageFlag = EnvSetting.LANGUAGE_CONFIG.defaultLanguageFlag;
        this.selectedLangExpireDate.setDate(this.selectedLangExpireDate.getDate() + 1);
        if (EnvSetting.language.LanguageOverRule) {
          this.currentLang = EnvSetting.language.LanguageOverRuleDefault
          this.currentLanguageService.currentLanguage.next(EnvSetting.language.LanguageOverRuleDefault);
          this.cookieservice.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false, "Strict");
          this.translate.use(this.currentLang);
        }
        else {
          this.getAllLanguage(this.currentLang);
        }
      }
    });
    //  this.currentSignedInUser = this.userService.currentUserValue.name
    this.userService.currentUser.subscribe((user) => {
      if (user) {
        this.currentUserRole = user.roleTypeText;
        this.currentSignedInUser = user.name;
        this.isShowNotification = !!user.userRoleMenuDetails.find(x => x.moduleId === fromEnums.ModuleNames.HeaderNotification)?.canView;
      }
    })
    setInterval(() => {
      this.currentDateTime = Promise.resolve(new Date());
    }, 1000);
    this.languageSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.setTitle()
    });
    this.initNotificationConfig();
  }

  ngOnDestroy() {
    if (this.whatsAppNotificationInterval) {
      clearInterval(this.whatsAppNotificationInterval);
    }
    if (this.stampTimeSubscription) {
      this.stampTimeSubscription.unsubscribe();
    }
  }

  private listenRouting() {
    let routerUrl: string;

    this.router.events.subscribe((router: any) => {
      routerUrl = router.urlAfterRedirects;
      if (routerUrl && typeof routerUrl === 'string') {
        let root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
        this.setTitle()
        if (this.breadcrumbs && this.breadcrumbs.length > 0) {
          this.currentLanguageService.breadcrumbs.next(this.breadcrumbs);
        }
      }
    })
  }
  private setTitle() {
    const rt = this.getChild(this.activatedRoute);
    rt.data.subscribe(data => {
      if (data.title) {
        this.translate.get(data.title).subscribe((_translated: string) => {
          const translation = this.translate.instant(data.title);
          this.titleService.setTitle(translation);
        });
      }
      else {
        this.titleService.setTitle('Administration')
      }
    });
  }
  getWhatsappNotification() {
    this.isShowWhatsAppNotification = true;
    this.getUnrepliedWhatsAppMessages();
    this.whatsAppNotificationInterval = setInterval(() => {
      this.getUnrepliedWhatsAppMessages();
    }, this.whatsAppNotificationRefreshInterval);
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
  private getBreadcrumbs(route: ActivatedRoute, url: string = "", breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {

    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";

    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      //append route URL to URL
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: IBreadcrumb = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        params: child.snapshot.params,
        url: url
      };
      if (breadcrumb.label !== '') {
        breadcrumbs.push(breadcrumb);
      }
      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }

  onLogout() {
    let modelHeadermsg = this.translate.instant('lblLogout');
    let modelBodymsg = this.translate.instant('lblConfirmLogout');
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.logoutUser();
        }
      }
    );
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  logoutUser() {
    localStorage.removeItem('userLocale');
    p.publicIpv4().then((res) => {
      if (res) {
        let baseURL = environment.msalConfig.redirectUri.replace(/\/$/, "");
        let url = baseURL + this.router.url;
        this.stampInOut();
        localStorage.removeItem(Constant.UserLoggedId)
        localStorage.removeItem("Theme")
        this.userService.SetLoginActivity(false, res, url).then(
          _response => {
            this.secureStorage.removeAllKey();
          });
      }
    });
  }

  onReadAll() {
    this.notificationPopupOpen = false;
    this.router.navigateByUrl('/view-all-notifications');
  }

  async markAllRead() {
    const userId = this.userService.currentUserValue.userId;
    if (userId && this.notificationCount > 0) {
      this.dashboardService.NotificationMarkAllAsRead(userId).then(response => {
        if (response) {
          this.GetNotifications();
        }
      });
    }
  }

  onNotificationClick() {
    if ((this.isUserStampInOutActive && this.stampInTime !== '') || (!this.isUserStampInOutActive)){
      this.notificationPopupOpen = !this.notificationPopupOpen;
    } 
    else if (this.isUserStampInOutActive && this.stampInTime === '') {
      let warningMessage = this.translate.instant("lblPleaseStampInFirst");
      this.toaster.warning(warningMessage);
    }
  }


  @HostListener('document:click', ['$event'])
  onNotificationClose(event) {
    if (event && this.isShowNotification) {
      if (!this._eref.nativeElement.getElementsByClassName('notification-box')[0]?.contains(event.target)) {
        this.notificationPopupOpen = false;
      }
    }
    else {
      this.notificationPopupOpen = false;
    }
  }

  getAllLanguage(lang: string) {
    this.isLanguageDropDown = true;
    this.cookieservice.delete('userSelectedLanguage');
    if (this.msalService.instance.getAllAccounts().length) {
      this.languageService.getAllLanguage().then((response) => {
        this.languages = response.filter(x => x.key != 'de-DE' && x.key != 'fr-FR');
        if (this.isCookiesExist()) {
          this.currentLang = this.cookieservice.get('userSelectedLanguage');
          this.selectedLanguageText = this.languages.find(search => search.key === this.currentLang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languages.find(search => search.key === this.currentLang).flagName);
        }
        else if (lang != null) {
          this.currentLang = this.languages.find(search => search.key === lang).key;
          this.selectedLanguageText = this.languages.find(search => search.key === lang).value;
          this.selectedLanguageFlag = this.getFlagImage(this.languages.find(search => search.key === lang).flagName);
        }
        else {
          this.currentLang = response[0].key;
          this.selectedLanguageText = response[0].value;
          this.selectedLanguageFlag = this.getFlagImage(response[0].flagName);
        }
        this.cookieservice.set('userSelectedLanguage', this.currentLang, this.selectedLangExpireDate, '/', '', false, "Strict");
        this.currentLanguageService.LanguageList = this.languages;
        this.translate.use(this.currentLang);
        this.setTitle();
      });
    }

  }
  private isCookiesExist(): boolean {
    return this.cookieservice.check('userSelectedLanguage');
  }
  getFlagImage(flag: string) {
    if (flag) {
      let uri = "assets/images/countryflags/"
      return uri + flag;
    }
    else {
      return '../../../assets/images/no-image-icon.png'
    }
  }

  ChangeLanguage(languageCode: string) {
    this.cookieservice.set('userSelectedLanguage', languageCode, this.selectedLangExpireDate, '/', '', false, "Strict");
    this.translate.use(languageCode);
    this.currentLang = languageCode;
    this.selectedLanguageText = this.languages.find(search => search.key === languageCode).value;
    this.selectedLanguageFlag = this.getFlagImage(this.languages.find(search => search.key === languageCode).flagName);
    this.currentLanguageService.currentLanguage.next(this.currentLang);
  }

  //#region Push Notification
  initNotificationConfig() {
    this.userService.GetUserDetails().then(res => {
      //Removed this "|| res.roleType == UserRoles.Mechanic" from condition to login mechanic in smart planner. on 23 July 24 by dharmendra.
      if (res.responseCode === 401) {
        this.logoutUser();
      }
      else {
        const userId = res.userId;
        this.GetNotifications();
        if (userId) {
          const connection = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Critical)
            .withUrl(`${EnvSetting.PUSH_NOTIFICATION_API_URI}PushNotification?userId=${userId}`)
            .withAutomaticReconnect()
            .build();

          connection.start().catch(function (err) {
            return console.log(err);
          }).then(function () {
            connection.invoke('GetConnectionId').then(function (_connectionId) {
              // This is intentional
            });
          });
          this.globalSetting.signalrConnection.next(connection);
          connection.on(SignalRHubEventType.UserNotification, (_data) => {
            this.GetNotifications();
          });
          connection.on(SignalRHubEventType.AppointmentUpdated, (data) => {
            this.RefreshConfirmPopup(data, fromEnums.SignalRHubEventType.AppointmentUpdated);
          });
          connection.on(SignalRHubEventType.DocumentUploaded, (data) => {
            this.DocumentUploaded(data);
          });
          if (this.userService?.currentUserValue?.userRoleMenuDetails?.find(x => x.moduleId === ModuleNames.IncomingAndOutgoingCalls)?.canView) {
            this.isCdssUser = true;
            this.GetCallFromNumber();
            connection.on(SignalRHubEventType.OnCall, (data) => {
              this.QuickInfoForCall(data);
            });
            this.activatedRoute.queryParams.subscribe(params => {
              if (params) {
                this.OnIncommingCallFromRoute(params, res);
              }
            });
          }
        }
      }
    });
  }
  get getUserObj() {
    return this.secureStorage.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
  }
  async GetNotifications() {
    const userId = this.getUserObj.userId;
    if (userId && this.isShowNotification) {
      this.notifictionRequestModel.userId = userId;
      this.notifictionRequestModel.isRead = "UNREAD";
      this.notificationList = await this.dashboardService.GetNotifications(this.notifictionRequestModel);
      if (this.notificationList && this.notificationList.length > 0) {
        this.notificationCount = this.notificationList[0].totalCount;
      }
      else {
        this.notificationCount = 0;
      }
    }
  }
  GetFeature() {
    this.currentLanguageService.featureList.subscribe(
      (res) => {
        this.lstFeatures = res;
        this.isPbxEnabled = this.lstFeatures.find(x => x.featureCode === FeatureCode.Pbx)?.isActive;
        this.editAppointmentService.isLockFeatureEnabled = this.lstFeatures.find(x => x.featureCode === FeatureCode.AppointmentLock)?.isActive;
        this.isWhatsappFeatureActive = this.lstFeatures.find(x => x.featureCode === FeatureCode.WhatsApp)?.isActive;
        this.isUserStampInOutActive = this.lstFeatures.find(x => x.featureCode === FeatureCode.UserStampInOut)?.isActive;

        if (this.isWhatsappFeatureActive) {
          this.getWhatsappNotification()
        }
        if (this.isUserStampInOutActive) {
          let isEnableStampIn = this.getUserObj.isEnableStampIn;
          this.isUserStampInOutActive = isEnableStampIn ? this.isUserStampInOutActive : isEnableStampIn;
          this.SetTimeStamp();
        }
      }
    );
  }
  SetTimeStamp() {
    // Using RxJS Timer
    this.stampTimeSubscription = timer(0, 1000)
    .pipe(
      map(() => {
       if (this.userService.userStampIn) {
         const currentTime = new Date(moment.parseZone(new Date()).utc().format()).getTime();
         const stampInTime = new Date(this.userService.userStampIn + 'Z').getTime();
         const timeDiff = currentTime - stampInTime;
         return timeDiff;
       }
       return 0;
     }),
      share()
    )
    .subscribe(timeDiff => {
     this.stampInTime = '';
      if (timeDiff != 0) {
       // Total number of seconds in the difference
       const totalSeconds = Math.floor(timeDiff / 1000);

       // Total number of minutes in the difference
       const totalMinutes = Math.floor(totalSeconds / 60);

       // Total number of hours in the difference
       const totalHours = Math.floor(totalMinutes / 60);

       // Getting the number of seconds left in one minute
       const remSeconds = totalSeconds % 60;

       // Getting the number of minutes left in one hour
       const remMinutes = totalMinutes % 60;
       this.stampInTime = `${totalHours < 10 ? 0 : ''}${totalHours}:${remMinutes < 10 ? 0 : ''}${remMinutes}:${remSeconds < 10 ? 0 : ''}${remSeconds}`;
      }
    });
  }
  //#endregion

  //#region Call Methods
  GetCallFromNumber() {
    this.spinner.show();
    this.cultureLocaleService.globalSettingValues.subscribe((response) => {
      let result = response.find(x => x.property === "CallFromNumber");
      this.spinner.hide();
      if (result && !result?.value) {
        if (result.value == 'FROM_USER') {
          this.callFromNumber = this.getUserObj.mobileNo;
        }
        else {
          this.callFromNumber = result.value;
        }
      }
    });
  }
  OpenCallerPopup(){
    this.QuickInfoForCall(this.callerService.callerInfo);
  }
  QuickInfoForCall(callerInfo) {
    const modalref = this.modalService.open(CallerInfoComponent, { size: 'lg', windowClass: 'pop-wid1366 pop-mh80', backdrop: 'static' });
    modalref.componentInstance.callerInfoRequest = callerInfo;
    this.callerService.callerInfo = null;
    
    if (callerInfo?.callHistory?.CallHistoryId > 0) { // Pbx Socket
      this.currentLanguageService.callHistoryId.next(callerInfo?.callHistory?.CallHistoryId?.toString());
      this.callPopupList.push({ modal: modalref, id: callerInfo?.callHistory?.CallHistoryId });
    }
    else if (callerInfo?.callHistory?.callHistoryId > 0) { // Telenor
      this.currentLanguageService.callHistoryId.next(callerInfo?.callHistory?.callHistoryId?.toString());
      this.callPopupList.push({ modal: modalref, id: callerInfo?.callHistory?.callHistoryId });
    }

    modalref.result.then(
      (response) => {
        if (response?.closeAll == 1) {
          const historyIds = [];
          this.callPopupList.forEach(mref => {
            mref.modal.close({ success: false, closeAll: false });
            historyIds.push(mref.id);
          });
          this.callPopupList = [];
          this.currentLanguageService.callHistoryId.next("");
          this.callerService.updateCallEndAll(historyIds);
        }
        else if (response?.closeAll == 2 && callerInfo?.callHistory?.CallHistoryId > 0) { // Pbx Socket
          let callObj = {
            CallHistoryId: callerInfo.callHistory.CallHistoryId,
            CallId: callerInfo.callHistory.CallId
          }
          this.currentLanguageService.callHistoryId.next("");
          this.callerService.updateCallEnd(callObj);
        }
        else if (response?.closeAll == 2 && callerInfo?.callHistory?.callHistoryId > 0) { // Telenor
          let callObj = {
            CallHistoryId: callerInfo.callHistory.callHistoryId,
            CallId: callerInfo.callHistory.callId
          }
          this.currentLanguageService.callHistoryId.next("");
          this.callerService.updateCallEnd(callObj);
        }
      }
    );
  }
  stampInOut(isStampIn = false) {
    this.userService.setUserStampInOut(isStampIn);
  }
  DialCall(dialContent){
    if ((this.isUserStampInOutActive && this.stampInTime !== '') || (!this.isUserStampInOutActive)){
      const modalRef = this.modalService.open(dialContent, {ariaLabelledBy: 'modal-basic-title', size: 'md'})
      modalRef.result.then(
        (_result) => {
          // This is intentional
        },
        (reason) => {
          if (reason) {
            this.InitiateCall(modalRef)
          }
        });
    } 
    else if (this.isUserStampInOutActive && this.stampInTime === '') {
      let warningMessage = this.translate.instant("lblPleaseStampInFirst");
      this.toaster.warning(warningMessage);
    }
  }
  InitiateCall(modalRef) {
    let errorMsg = this.translate.instant('lblErrormsgs');
    let failedMsg = this.translate.instant('lblDialFailed');
    let successMsg = this.translate.instant('lblDialSuccess');
    if (this.dialNumber) {
      let model: CallDialRequestModel = {
        Number: this.getUserObj.mobileNo,
        CustomerId: 0,
        DestinationNumber: this.dialNumber,
        CallerId: this.callFromNumber
      }
      this.spinner.show();
      this.callerService.callDial(model).then((response) => {
        let result = response.responseObject;
        this.spinner.hide();
        if (result && !result?.error) {
          this.toaster.success(successMsg);
          this.dialNumber = "";
          modalRef.close();
        } else {
          this.toaster.error(failedMsg);
        }
      }).catch((_err) => {
        this.spinner.hide();
        this.toaster.error(errorMsg);
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }
  OnIncommingCallFromRoute(params, user) {
    if (params && user.mobileNo && params.ct) {
      let model: CallHistoryRequestModel = {
        CallFromNo: params.ct,
        CallId: params.qid,
        CallToNo: user.mobileNo,
      };
      this.callerService.addCallHistory(model).then((response) => {
        let result = response.responseObject;
        if (result && !result?.error) {
          this.QuickInfoForCall({
            mobileNo: params.ct,
            agentUserId: user.id,
            agentMobile: user.mobileNo,
            callHistory: result,
            languageCode: this.currentLang
          });
        }
      })
    }
  }
  //#endregion

  //#region Common connection methods
  RefreshConfirmPopup(data, type) {
    if (type == fromEnums.SignalRHubEventType.AppointmentUpdated) {
      if (data?.appointmentId > 0 && data.appointmentId == this.editAppointmentService.appointmentDetails?.id) {
        //TODO: removed temporary
        // let modelHeadermsg = this.translate.instant('lblAppointmentUpdated');
        // let modelBodymsg = this.translate.instant('lblAppointmentRefreshMsg');
        // const updatedModalRef = this.modalService.open(NgInfoModalContent);
        // updatedModalRef.componentInstance.modelHeader = modelHeadermsg;
        // updatedModalRef.componentInstance.modelBody = modelBodymsg;
      }
    }
  }
  DocumentUploaded(data) {
    if (data?.appointmentId > 0 && data.appointmentId == this.editAppointmentService.appointmentDetails?.id) {
      this.appointmentService.GetDocumentCount(data.appointmentId).then((res) => {
        if (res?.responseObject?.length > 0) {
          this.editAppointmentService.DemandWiseDocumentCountList = res.responseObject;
        }
      })
    }
  }
  //#endregion

  /***
   * WhatsApp reply delayed notifications
   *
   */

  viewAllUnrepliedWhatsAppMessages() {
    this.whatsAppNotificationPopupOpen = false;
    this.whatsAppLogService.setUnrepliedMessageFilter();
    if (this.router.url === '/appointment') {
      window.location.reload();
    }
    else {
      this.router.navigate(['/appointment']);
    }
  }

  private getUnrepliedWhatsAppMessages() {
    this.whatsAppLogService.getUnrepliedWhatsAppMessages().then(res => {
      if (res.responseCode === Constant.SuccessResponseCode) {
        this.unrepliedWhatsAppMessages = res.responseObject;
        this.whatsAppNotificationCount = this.unrepliedWhatsAppMessages.length;
      }
    }).catch(_err => {
      console.log(_err);
    });
  }

  onWhatsAppNotificationClick() {
    this.whatsAppNotificationPopupOpen = !this.whatsAppNotificationPopupOpen;
  }

  showWarningMsg() {
    let warningMsg = this.translate.instant("lblStampInRequired");
    this.toaster.warning(warningMsg);
  }
}
